/**
 * Order source attribution (multi-touch journey)
 *
 * Tracks banner → collection → pdp (etc.), then attaches on add-to-cart:
 *   - line item property `_src` → "hero-banner, halloween-shop, pdp"
 *   - cart attribute `src_tags` → "src-hero-banner,src-halloween-shop,src-pdp"
 *
 * Also keeps hidden form inputs + cart attributes in sync so Buy Now / checkout
 * still carry attribution when possible.
 */
(function () {
  if (window.PlatiniOrderSource) return;

  var PROP_KEY = '_src';
  var ATTR_KEY = 'src_tags';
  var ATTR_KEY_LEGACY = '_src_tags';
  var STORAGE_KEY = 'platini_src_journey';
  var lastPointerEl = null;
  var pendingSource = '';
  var syncTimer = null;

  function normalize(raw) {
    if (!raw) return '';
    return String(raw)
      .toLowerCase()
      .trim()
      .replace(/^src[-_]/, '')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');
  }

  function readJourney() {
    try {
      var raw = sessionStorage.getItem(STORAGE_KEY);
      if (!raw) return [];
      var parsed = JSON.parse(raw);
      return Array.isArray(parsed) ? parsed.map(normalize).filter(Boolean) : [];
    } catch (e) {
      return [];
    }
  }

  function writeJourney(list) {
    try {
      sessionStorage.setItem(STORAGE_KEY, JSON.stringify(list));
    } catch (e) {}
  }

  function pushJourney(source) {
    var src = normalize(source);
    if (!src) return readJourney();
    var list = readJourney();
    if (list.indexOf(src) === -1) list.push(src);
    writeJourney(list);
    syncFormInputs(list);
    scheduleCartSync(list);
    return list;
  }

  function tagsFromJourney(list) {
    return (list || [])
      .map(function (s) {
        return 'src-' + s;
      })
      .join(',');
  }

  function mergeTagStrings(a, b) {
    var set = {};
    String(a || '')
      .split(',')
      .concat(String(b || '').split(','))
      .forEach(function (part) {
        var t = part.trim();
        if (t) set[t] = true;
      });
    return Object.keys(set).join(',');
  }

  function resolveFromEl(el) {
    if (!el || !el.closest) return '';
    var node = el.closest('[data-order-src]');
    if (node) {
      var fromNode = normalize(node.getAttribute('data-order-src'));
      if (fromNode) return fromNode;
    }
    var modal = el.closest('quick-add-modal');
    if (modal && modal.dataset && modal.dataset.orderSrc) {
      return normalize(modal.dataset.orderSrc);
    }
    return '';
  }

  function resolveFallback() {
    var path = (window.location && window.location.pathname) || '';
    if (path.indexOf('/products/') !== -1) return 'pdp';
    if (path.indexOf('/collections/') !== -1) return 'collection-quick-add';
    if (path.indexOf('/cart') !== -1) return 'cart';
    if (path.indexOf('wishlist') !== -1) return 'wishlist';
    if (path === '/' || path === '') return 'homepage';
    return 'storefront';
  }

  function resolveClickSource(el) {
    return (
      resolveFromEl(el) ||
      resolveFromEl(lastPointerEl) ||
      resolveFromEl(document.activeElement) ||
      normalize(pendingSource) ||
      resolveFallback()
    );
  }

  function journeyForAdd(clickSource) {
    var list = readJourney().slice();
    var click = normalize(clickSource);
    if (click && list.indexOf(click) === -1) list.push(click);
    if (!list.length && click) list = [click];
    return list;
  }

  function rememberPointer(el) {
    if (!el) return;
    lastPointerEl = el;
    var src = resolveFromEl(el);
    if (src) pendingSource = src;
  }

  function ensureHiddenInput(form, name, value) {
    if (!form) return;
    var input = form.querySelector('input[name="' + name + '"]');
    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      input.name = name;
      form.appendChild(input);
    }
    input.value = value;
  }

  function syncFormInputs(list) {
    var journey = list || readJourney();
    if (!journey.length) return;
    var srcValue = journey.join(', ');
    var tagValue = tagsFromJourney(journey);
    document.querySelectorAll('form[action*="/cart/add"]').forEach(function (form) {
      ensureHiddenInput(form, 'properties[' + PROP_KEY + ']', srcValue);
      ensureHiddenInput(form, 'attributes[' + ATTR_KEY + ']', tagValue);
    });
  }

  function scheduleCartSync(list) {
    clearTimeout(syncTimer);
    syncTimer = setTimeout(function () {
      syncCartTags(list || readJourney());
    }, 400);
  }

  function syncCartTags(journey) {
    if (!journey || !journey.length) return;
    var tagValue = tagsFromJourney(journey);
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) {
        return r.json();
      })
      .then(function (cart) {
        var attrs = (cart && cart.attributes) || {};
        var existing = attrs[ATTR_KEY] || attrs[ATTR_KEY_LEGACY] || '';
        var merged = mergeTagStrings(existing, tagValue);
        if (merged === existing && attrs[ATTR_KEY] === merged) return null;
        var next = {};
        next[ATTR_KEY] = merged;
        next[ATTR_KEY_LEGACY] = merged;
        return fetch('/cart/update.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
          credentials: 'same-origin',
          body: JSON.stringify({ attributes: next }),
        });
      })
      .catch(function () {});
  }

  document.addEventListener(
    'pointerdown',
    function (e) {
      rememberPointer(e.target);
    },
    true
  );

  document.addEventListener(
    'click',
    function (e) {
      rememberPointer(e.target);
      var target = e.target;
      if (!target || !target.closest) return;

      var sourced = resolveFromEl(target);
      if (sourced) {
        pushJourney(sourced);
        pendingSource = sourced;
      }

      var opener = target.closest('[data-product-url]');
      if (opener) {
        var src = resolveClickSource(opener);
        if (src) {
          pushJourney(src);
          var modal =
            opener.closest('quick-add-modal') ||
            document.querySelector('quick-add-modal#CartDrawerQuickAdd') ||
            document.querySelector('quick-add-modal');
          if (modal) modal.dataset.orderSrc = src;
          pendingSource = src;
        }
      }
    },
    true
  );

  function stampPageContext() {
    var page = window.PlatiniOrderSourcePage || {};
    var params = new URLSearchParams(window.location.search || '');
    var fromQuery = normalize(params.get('src') || params.get('order_src') || '');
    if (fromQuery) pushJourney(fromQuery);
    if (page.collection) pushJourney(page.collection);
    if (page.template === 'product') pushJourney('pdp');

    var journey = readJourney();
    syncFormInputs(journey);
    if (journey.length) scheduleCartSync(journey);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', stampPageContext);
  } else {
    stampPageContext();
  }

  function injectJsonPayload(payload, journey) {
    if (!payload || !journey || !journey.length) return payload;
    var srcValue = journey.join(', ');
    var tagValue = tagsFromJourney(journey);

    if (Array.isArray(payload.items)) {
      payload.items.forEach(function (item) {
        if (!item || typeof item !== 'object') return;
        item.properties = item.properties || {};
        item.properties[PROP_KEY] = srcValue;
      });
    } else if (payload.id != null) {
      payload.properties = payload.properties || {};
      payload.properties[PROP_KEY] = srcValue;
    }

    payload.attributes = payload.attributes || {};
    payload.attributes[ATTR_KEY] = mergeTagStrings(payload.attributes[ATTR_KEY], tagValue);
    payload.attributes[ATTR_KEY_LEGACY] = mergeTagStrings(
      payload.attributes[ATTR_KEY_LEGACY],
      tagValue
    );
    return payload;
  }

  function injectFormData(fd, journey) {
    if (!fd || !journey || !journey.length) return;
    var srcValue = journey.join(', ');
    var tagValue = tagsFromJourney(journey);
    var propKey = 'properties[' + PROP_KEY + ']';
    if (typeof fd.set === 'function') fd.set(propKey, srcValue);
    else fd.append(propKey, srcValue);

    [ATTR_KEY, ATTR_KEY_LEGACY].forEach(function (key) {
      var attrKey = 'attributes[' + key + ']';
      var prev = typeof fd.get === 'function' ? fd.get(attrKey) : '';
      var merged = mergeTagStrings(prev, tagValue);
      if (typeof fd.set === 'function') fd.set(attrKey, merged);
      else fd.append(attrKey, merged);
    });
  }

  function isCartAddUrl(url) {
    return typeof url === 'string' && url.indexOf('/cart/add') !== -1;
  }

  var nativeFetch = window.fetch;
  window.fetch = function (input, init) {
    var url = '';
    try {
      url = typeof input === 'string' ? input : (input && input.url) || '';
    } catch (e) {
      url = '';
    }

    if (!isCartAddUrl(url)) {
      return nativeFetch.apply(this, arguments);
    }

    init = init ? Object.assign({}, init) : {};
    var clickSource = resolveClickSource(lastPointerEl);
    var journey = journeyForAdd(clickSource);
    writeJourney(journey);
    syncFormInputs(journey);

    try {
      if (init.body && typeof init.body === 'string') {
        try {
          var parsed = JSON.parse(init.body);
          parsed = injectJsonPayload(parsed, journey);
          init.body = JSON.stringify(parsed);
        } catch (e) {}
      } else if (typeof FormData !== 'undefined' && init.body instanceof FormData) {
        injectFormData(init.body, journey);
      }
    } catch (e) {}

    return nativeFetch.call(this, input, init).then(function (response) {
      if (response && response.ok) {
        syncCartTags(journey);
      }
      return response;
    });
  };

  window.PlatiniOrderSource = {
    propertyKey: PROP_KEY,
    attributeKey: ATTR_KEY,
    normalize: normalize,
    push: pushJourney,
    getJourney: readJourney,
    resolve: resolveClickSource,
    getTagsString: function () {
      return tagsFromJourney(readJourney());
    },
    tagFor: function (source) {
      var s = normalize(source);
      return s ? 'src-' + s : '';
    },
  };
})();
